import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { Router } from '@angular/router';
import {LocalDataSource } from 'ng2-smart-table';
import { plainToClass } from 'class-transformer';
import swal from 'sweetalert2';
import { Message } from '../../shared/data/message';
import { Souscription } from '../../shared/data/souscription';
import { ShowSouscriptionComponent } from './show-souscription/show-souscription.component';

@Component({
  selector: 'ngx-souscription',
  templateUrl: './souscription.component.html',
  styleUrls: ['./souscription.component.scss']
})
export class SouscriptionComponent implements OnInit {
  fichier = "assets/images/eye-outline.png";
  source: LocalDataSource =  new LocalDataSource();
  constructor(private dialogService: NbDialogService,private apiService:ApiService, private sendeurService:EventSendeurService, private router:Router, private toastr:NbToastrService) { }

  ngOnInit() {
    this.getSouscription();
    this.sendeurService.messageCourant.subscribe(data =>{
      this.getSouscription();
    })
  }

 

  settings = {

    hideSubHeader: false,
    mode: 'external',
    
    actions: {
      columnTitle: '',
      position: 'left',
      add: false,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent:'<i class="fa fa-search-plus"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave:false
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
  columns: {
    id: {
      title: 'ID',
      type: 'number',
      filter: false,
    },
    type_souscription: {
      title: 'Type',
      type: 'number',
      filter: false,
    },
    num_titre_foncier: {
      title: 'Titre Foncier',
      type: 'string',
    },
    superficie: {
      title: 'Superficie',
      type: 'string',
    },
    localisation: {
      title: 'Localisation',
      type: 'number',
      filter: false,
    },
    username: {
      title: 'Compte',
      type: 'number',
      filter: false,
    },

   
  },
  pager : {
                perPage :10
  },
 
};



  

  select($event){
    this.dialogService.open(ShowSouscriptionComponent,{context:{id:$event.data.id}});
  }

  onDelete(event){
    
    // this.dialogService.open(DeleteConfirmMessageComponent,{context:{id:$event.data.id}});
    const message = plainToClass( Message,  event.data as object);
    
    swal({
      title: 'Suppression Message',
      text: 'Voulez - vous vraiment supprimer ' + message.objet + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteMessageProvider(message.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Supprimé(e)", message.objet);

      }

      // this.dialogIsNotShow = false;

    });

  }

  // createPage(){
  //   this.dialogService.open(AddPageComponent);
  // }


  getSouscription(){
    this.apiService.getAllSouscriptionProvider().subscribe(data =>{
      this.source.load( plainToClass(Souscription, data));

    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

}
